export default __webpack_public_path__ + "assets/delboni-component.973e9757.svg";